// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box[data-v-550fa03f]{padding:100px 0;background:#f7f8f9;position:relative}.box-main[data-v-550fa03f]{z-index:1}.chat-box .g-box[data-v-550fa03f]{min-height:0;padding-bottom:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
